export type AppLanguage = 'fr';

export interface LanguageOption {
  code: AppLanguage;
  shortLabel: string;
  label: string;
  nativeLabel: string;
}

export const SUPPORTED_LANGUAGES: readonly LanguageOption[] = [
  { code: 'fr', shortLabel: 'FR', label: 'Français', nativeLabel: 'Français' },
] as const;
